<template>
  <div>
    <div
      :class="`main-chatbot ${isOpen ? 'show' : ''} ${
        isFullScreen ? 'fullScreen' : ''
      }`"
    >
      <div class="chatbot-panel">
        <div class="chatbot-header">
          <div class="image">
            <img src="./../../assets/Julien.jpg" class="julien-logo" alt="" />
            <span>Welcome to JULIEN Kingdom</span>
          </div>
          <div>
            <span
              class="cursor"
              @click="toggleSidebar"
              :title="isSidebarVisible ? 'Hide history' : 'Show history'"
            >
              <i class="ri-history-line"></i>
            </span>

            <span
              :title="isFullScreen ? 'Minimize' : 'Fullscreen'"
              @click="isFullScreen = !isFullScreen"
              class="cursor"
            >
              <i
                :class="
                  isFullScreen
                    ? 'ri-collapse-diagonal-line'
                    : 'ri-expand-diagonal-fill'
                "
              ></i>
            </span>
            <span title="Close" class="cursor" @click="toggleJulien">
              <i class="ri-close-line"></i>
            </span>
          </div>
        </div>
        <div :class="['chatbot-body']">
          <div
            :class="`chat-conversation ${
              isSidebarVisible ? 'with-sidebar' : 'no-sidebar'
            }`"
          >
            <!-- LEFT SIDEBAR (Conversation list) -->
            <aside
              class="left-sidebar"
              v-if="isSidebarVisible"
              aria-label="Chat history"
            >
              <div class="sidebar-top">
                <button class="new-chat-btn" @click="startNewChat">
                  + New chat
                </button>
              </div>

              <div class="history-container">
                <template v-if="historyLoading">
                  <div class="loading">
                    <span
                      class="spinner"
                      style="width: 16px; height: 16px"
                    ></span>
                  </div>
                </template>

                <template v-if="julienHistory.length === 0">
                  <div class="empty">No conversations</div>
                </template>

                <template v-else>
                  <div
                    v-for="item in julienHistory"
                    :key="item.session_uid || item.id"
                    class="history-row"
                    :class="{
                      active:
                        currentSessionUid ===
                        (item.session_uid || item.sessionId),
                    }"
                  >
                    <div
                      class="history-info"
                      @click="loadHistory(item.session_uid || item.sessionId)"
                    >
                      <div class="history-title">
                        {{ item.header || item.title || "Untitled" }}
                      </div>
                    </div>

                    <!-- per-item delete button (stop click to avoid triggering load) -->
                    <!-- <button
                      class="tiny-clear"
                      title="Delete conversation"
                      @click="
                        showModal = true;
                        deletingSessionUid = item.session_uid || item.sessionId;
                      "
                      :disabled="historyLoading"
                    >
                      <template
                        v-if="
                          deletingSessionUid ===
                          (item.session_uid || item.sessionId)
                        "
                      >
                        <span
                          class="spinner"
                          style="width: 16px; height: 16px"
                        ></span>
                      </template>
                      <template v-else>
                        <i class="ri-delete-bin-6-line"></i>
                      </template>
                    </button> -->
                    <!-- <i class="ri-delete-bin-6-line"></i> -->
                  </div>
                </template>
              </div>

              <!-- <div class="sidebar-bottom">
                <button
                  class="refresh-btn"
                  @click="refreshHistory"
                  :disabled="historyLoading"
                >
                  <i class="ri-refresh-line"></i> Refresh
                </button>
                <button
                  class="clear-all-btn"
                  @click="confirmClearAll"
                  :disabled="historyLoading || julienHistory.length === 0"
                >
                  Clear all
                </button>
              </div> -->
            </aside>

            <!-- MAIN CHAT AREA -->
            <div class="main-chat-body">
              <main class="chat-area">
                <div id="scroll-container" class="chat-section-wrapper">
                  <!-- new -->
                  <div
                    v-for="data in julienData"
                    :key="data.id"
                    :class="`chat-section ${
                      data.userRequest ? 'chat-user' : ''
                    }`"
                  >
                    <div v-if="data.userRequest" class="image-user">
                      <span class="user-logo">
                        <i class="ri-account-circle-line user-icon"></i>
                      </span>
                    </div>
                    <div v-else class="image">
                      <img
                        src="./../../assets/Julien.jpg"
                        class="profile-logo"
                        alt=""
                      />
                    </div>
                    <div class="content">
                      <div class="d-flex gap-2">
                        <b>{{ data.userRequest ? "You" : "JULIEN" }}</b>
                        <small>{{ data.timestamp }}</small>
                      </div>
                      <div class="mt-2">
                        <template v-if="data.isProcessing">
                          Processing<span class="processing-dots"
                            ><span>...</span>
                          </span>
                        </template>
                        <template v-else>
                          <span class="multiline-text">
                            {{ data.message }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                  <!-- new -->
                </div>
              </main>

              <div class="chat-group-wrapper">
                <div class="julien-disclaimer">
                  Julien is an AI assistant. Responses are auto-generated and
                  may not always be accurate. For important queries, please
                  cross-check with support teams.
                </div>
                <!-- input area -->
                <div class="chatbot-input">
                  <textarea
                    v-model="query"
                    type="text"
                    @keyup="julienKeyUp"
                    placeholder="Ask JULIEN..."
                  >
                  </textarea>
                  <!-- <input type="file" id="attachFile" class="d-none" /> -->
                  <div class="button-wrapper">
                    <!-- <label title="Select File" for="attachFile" class="attach-file"
                  ><i class="ri-attachment-2"></i
                ></label> -->
                    <button
                      title="Send"
                      class="send-btn"
                      @click="sendResponse"
                      :disabled="loading"
                    >
                      <template v-if="loading">
                        <span class="spinner" style="margin-right: 6px"></span>
                      </template>
                      <template v-else> ➤ </template>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isOpen && !isFullScreen"
      class="backdrop"
      @click="toggleJulien"
    ></div>
    <button
      title="Julien"
      class="chatbot-btn chatbot-toggle lively"
      @click="toggleJulien"
    >
      <i class="ri-robot-2-line ri-lg"></i>
    </button>

    <div class="modal-overlay" v-if="showModal">
      <div class="inside-modal">
        <div class="modal-header">
          <span>Confirm Delete</span>
          <button class="modal-close" @click="closeModal">
            <i class="ri-close-line"></i>
          </button>
        </div>
        <div class="modal-body">
          Are you sure you want to delete this conversation?<br />
          This will end the session.
        </div>

        <div class="modal-footer">
          <button class="modal-btn cancel" @click="closeModal">Cancel</button>
          <button
            class="modal-btn confirm"
            @click="
              endSession(deletingSessionUid);
              showModal = false;
            "
            :disabled="historyLoading"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { ref, onMounted, nextTick } from "vue";
import { useAuthStore } from "@/store/auth";
const authStore = useAuthStore();

const isOpen = ref(false);
const isFullScreen = ref(false);
const isShowSidebar = ref(false);
const query = ref("");
const julienData = ref([
  {
    id: 1,
    userRequest: false,
    message: "Hello, how can I assist you today?",
    timestamp: new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
  },
]);

const JulienKey = "julien";
const loading = ref(false);

onMounted(() => {
  const storedData = sessionStorage.getItem(JulienKey);
  if (storedData) {
    julienData.value = JSON.parse(storedData);
  }
});

// history state
const isSidebarVisible = ref(true);
const julienHistory = ref([]);
const historyLoading = ref(false);
const historyError = ref("");
const currentSessionUid = ref(null);
const JulianKey = "julien";

const fetchJulienHistory = async () => {
  historyLoading.value = true;
  try {
    const response = await axios.get("/julien/history");
    julienHistory.value = response.data.History;
  } catch (error) {
    console.error("Error fetching Julien history:", error);
  } finally {
    historyLoading.value = false;
  }
};

const toggleSidebar = () => {
  // if user toggles to open and history empty, fetch it
  if (!isSidebarVisible.value && julienHistory.value.length === 0) {
    fetchJulienHistory();
  }
  isSidebarVisible.value = !isSidebarVisible.value;
};

const startNewChat = () => {
  currentSessionUid.value = null;
  julienData.value = [
    {
      id: 1,
      userRequest: false,
      message: "Hi — started a new conversation. How can I help?",
      timestamp: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    },
  ];
  sessionStorage.setItem(JulianKey, JSON.stringify(julienData.value));
};

// Load a session's chat history and convert chat_history -> messages (user then bot)
const loadHistory = async (sessionUid) => {
  if (!sessionUid) return;
  historyLoading.value = true;
  historyError.value = "";
  try {
    const res = await axios.get(`/julien/history/chat/${sessionUid}`);
    const data = res.data || {};
    const chatHistory = Array.isArray(data.chat_history)
      ? data.chat_history
      : [];

    const normalized = [];
    chatHistory.forEach((entry) => {
      const userText = entry.query || entry.userQuery || "";
      const botText = entry.message || entry.botMessage || "";

      if (userText) {
        normalized.push({
          id: normalized.length + 1,
          userRequest: true,
          message: userText,
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        });
      }
      if (botText) {
        normalized.push({
          id: normalized.length + 1,
          userRequest: false,
          message: botText,
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        });
      }
    });

    if (normalized.length === 0) {
      normalized.push({
        id: 1,
        userRequest: false,
        message:
          data.header || "No message details available for this session.",
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });
    }

    julienData.value = normalized;
    currentSessionUid.value = sessionUid;
    sessionStorage.setItem(JulianKey, JSON.stringify(julienData.value));

    await nextTick();
    const container = document.getElementById("scroll-container");
    if (container)
      container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
  } catch (err) {
    console.error("Error loading session", err);
    historyError.value = "Failed to load selected session.";
  } finally {
    historyLoading.value = false;
  }
};

const julienKeyUp = (event) => {
  if (event.key === "Enter" && !event.shiftKey) {
    event.preventDefault();
    sendResponse();
  }
};

const toggleJulien = () => {
  isOpen.value = !isOpen.value;
  if (isOpen.value) {
    fetchJulienHistory();
  }
  const container = document.getElementById("scroll-container");
  container.scrollTo({
    top: container.scrollHeight,
    // behavior: "smooth",
  });
  if (isOpen.value) {
    isFullScreen.value = false;
    isShowSidebar.value = false;
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
};

const deletingSessionUid = ref(null);
const showModal = ref(false);

const closeModal = () => {
  console.log("hi");
  showModal.value = false;
  deletingSessionUid.value = null;
};

const endSession = async (sessionUid) => {
  historyLoading.value = true;
  try {
    const res = await axios.post(
      "/julien/end-session",
      { session_uid: sessionUid },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: authStore.auth.token,
        },
      }
    );

    const removedUid = res.data?.session_uid || sessionUid;

    // remove from local history list
    julienHistory.value = julienHistory.value.filter(
      (s) => (s.session_uid || s.sessionId) !== removedUid
    );

    // if currently loaded session matches, clear main chat
    if (currentSessionUid.value === removedUid) {
      currentSessionUid.value = null;
      julienData.value = [
        {
          id: 1,
          userRequest: false,
          message: "This conversation was deleted.",
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        },
      ];
      sessionStorage.setItem(JulianKey, JSON.stringify(julienData.value));
    }
  } catch (err) {
    console.error("Error ending session", err);
    historyError.value = "Failed to delete the selected conversation.";
  } finally {
    historyLoading.value = false;
  }
};

const sendResponse = () => {
  if (!query.value.trim() || loading.value) return;
  const payload = {
    query: query.value,
  };
  // User message
  julienData.value.push({
    id: julienData.value.length + 1,
    userRequest: true,
    message: query.value,
    timestamp: new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
  });

  // Scroll to bottom after user message
  nextTick(() => {
    const container = document.getElementById("scroll-container");
    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  });

  query.value = "";
  loading.value = true;

  // Add temporary "Processing..." bot message
  const processingId = julienData.value.length + 1;
  julienData.value.push({
    id: processingId,
    userRequest: false,
    message: "Processing...",
    timestamp: new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
    isProcessing: true,
  });

  axios
    .post("/julien/ask", payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: authStore.auth.token,
      },
    })
    .then((response) => {
      // Find and replace the "Processing..." message
      const idx = julienData.value.findIndex(
        (msg) => msg.id === processingId && msg.isProcessing
      );
      if (idx !== -1) {
        julienData.value[idx] = {
          id: processingId,
          userRequest: false,
          message: response.data.message,
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        };
      }
      sessionStorage.setItem(JulienKey, JSON.stringify(julienData.value));
      nextTick(() => {
        const container = document.getElementById("scroll-container");
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: "smooth",
          });
        }
      });
      fetchJulienHistory();
    })
    .catch((error) => {
      // Replace with error message if needed
      const idx = julienData.value.findIndex(
        (msg) => msg.id === processingId && msg.isProcessing
      );
      if (idx !== -1) {
        julienData.value[idx] = {
          id: processingId,
          userRequest: false,
          message: "Sorry, something went wrong. Please try again.",
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        };
      }
      console.error("Error sending message:", error);
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style scoped>
.chatbot-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 60px;
  height: 60px;
  margin: 10px;
  box-shadow: 0 0 15px #ff6ec4;
  background: linear-gradient(135deg, #ff6ec4, #7873f5); /* Gradient */
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 28px;
  cursor: pointer;
  overflow: hidden;
  animation: pulse-glow 2.5s infinite ease-in-out;
  z-index: 998;
}
.main-chat-body {
  display: grid;
  height: 516px;
}

.chatbot-btn::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0.4),
    transparent,
    rgba(255, 255, 255, 0.4)
  );
  transform: rotate(45deg);
  animation: shine 3s infinite;
}

.julien-disclaimer {
  text-align: center;
  color: #b8007a;
  font-size: 8px;
  margin: 0 0 8px 0;
  padding: 6px 10px 0 10px;
  font-style: italic;
}

@keyframes shine {
  0% {
    transform: translate(-100%, -100%) rotate(45deg);
  }
  100% {
    transform: translate(100%, 100%) rotate(45deg);
  }
}

.chatbot-btn.lively {
  animation: pulse 2.5s infinite ease-in-out;
  transform-origin: center;
}

.chatbot-btn:hover {
  background: linear-gradient(to right, #ea479a, #9433e9);
  box-shadow: 0 6px 14px rgba(234, 71, 154, 0.5);
  transform: scale(1.05);
}

.main-chatbot {
  position: fixed;
  height: 570px; /* Reduced height */
  bottom: 15px;
  right: 20px;
  width: 850px;
  z-index: 999;
  opacity: 0;
  transform: translateY(60px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.main-chatbot.show {
  opacity: 1;
  transform: translateY(0px);
  pointer-events: unset;
}

.main-chatbot.fullScreen {
  width: 100%;
  right: 0px;
  top: 0px;
  bottom: 0px;
  height: 100vh;
  padding: 10px;
  background-color: white;
}

/* Left sidebar */
.left-sidebar {
  border-right: 1px solid #eee;
  background: #fafafa;
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  height: 516px;
}

.sidebar-top {
  margin-bottom: 10px;
}
.new-chat-btn {
  background: #fff;
  color: #cc007a;
  border: 1px solid #cc007a;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  width: 100%;
}

/* History container */
.history-container {
  overflow-y: auto;
  flex: 1;
  padding-right: 6px;
}

.loading,
.empty {
  color: #777;
  padding: 8px;
  text-align: center;
}

/* history row */
.history-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #fff;
  border: 1px solid #eee;
  padding: 4px 10px;
  border-radius: 8px;
  margin-bottom: 4px;
  cursor: pointer;
}

.history-row:hover {
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04); */
  background-color: #8080802b;
}

.history-row.active {
  border: 1px solid #e6bded;
  background-color: #fef1ff;
  box-shadow: 0 4px 18px rgba(138, 43, 226, 0.06);
}

.history-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.history-title {
  font-weight: 500;
  font-size: 12px;
  color: #222;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.history-meta {
  font-size: 12px;
  color: #888;
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}
.meta-time {
  margin-left: auto;
  font-size: 11px;
  color: #999;
}

/* tiny delete button */
.tiny-clear {
  border: none;
  background: transparent;
  color: #c0392b;
  padding: 6px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 6px;
}
.tiny-clear:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* sidebar bottom */
.sidebar-bottom {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.refresh-btn,
.clear-all-btn {
  flex: 1;
  border: 1px solid #eee;
  background: #fff;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: #80808066;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inside-modal {
  background-color: white;
  /* padding: 10px; */
  border-radius: 12px;
  animation: modalIn 0.18s;
  width: 340px;
  box-shadow: 0 8px 32px rgba(138, 43, 226, 0.18);
}

@keyframes modalIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.modal-header {
  background: linear-gradient(to right, #9433e9, #ea479a);
  color: #fff;
  padding: 8px 18px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px 10px 0px 0px;
}

.modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.13);
}

.modal-body {
  padding: 16px 18px 10px 18px;
  color: #b8007a;
  font-size: 15px;
  line-height: 1.5;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 18px 10px 18px;
}

.modal-btn {
  border: none;
  border-radius: 6px;
  padding: 8px 18px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.18s;
}

.modal-btn.cancel {
  background: #f2f4f5;
  color: #9433e9;
  cursor: pointer;
  border: 1px solid #9433e9;
}

.modal-btn.cancel:hover {
  background: #e9e9e9;
}

.modal-btn.confirm {
  background: linear-gradient(to right, #ea479a, #9433e9);
  color: #fff;
  cursor: pointer;
}

.modal-btn.confirm:hover {
  background: linear-gradient(to right, #9433e9, #ea479a);
}

/* Main chat area */
.chat-area {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

@media screen and (max-width: 988px) {
  .main-chatbot {
    width: 100%;
    height: 100%;
    right: 0;
    bottom: 0;
    border-radius: 0;
    padding: 10px;
  }

  .left-sidebar,
  .main-chat-body {
    height: 560px;
  }
}

.multiline-text {
  white-space: pre-line;
  font-size: 12px;
}

/* Chatbot Panel */
.chatbot-panel {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.backdrop {
  position: fixed;
  inset: 0;
  z-index: 990;
  background-color: transparent;
  opacity: 0.2;
}

.cursor {
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 5px;
}

.cursor:hover {
  background-color: rgba(255, 255, 255, 0.14);
}

.chatbot-header {
  background: linear-gradient(to right, #9433e9, #ea479a); /* Gradient */
  color: white;
  padding: 10px 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.closeSize {
  font-size: 20px;
}

.chatbot-body {
  font-size: 14px;
  color: #333;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}

.chat-btn {
  background-color: white;
  border: 1px solid #3333332d;
  color: #333333;
  padding: 8px 10px;
  border-radius: 5px;
  width: 100%;
  display: flex;
  gap: 10px;
}

.hide-sidebar {
  display: none !important;
}

.show-sidebar {
  grid-column: 1/3;
}

.chat-sidebar {
  border-right: 1px solid #3333332d;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f9fbfc;
  /* height: 100%; */
}

.chat-conversation {
  display: grid;
  height: 100%;
}

.chat-conversation.no-sidebar {
  grid-template-columns: 1fr;
}

.chat-conversation.with-sidebar {
  grid-template-columns: 250px 1fr;
}

.chat-section-wrapper {
  flex: 1 1 0%;
  overflow-y: auto;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
}

.chat-sidebar {
  padding: 10px 16px;
}

.profile-logo {
  width: 30px;
  height: 30px;
  border-radius: 30px;
}

.user-icon {
  font-size: 20px;
  padding: 6px;
  border-radius: 30px;
  background-color: #9f35dead !important;
  color: white;
}

.julien-logo {
  width: 30px;
  height: 30px;
  border-radius: 20px;
  margin-right: 10px;
}

.image-user {
  margin-top: 6px;
}

.chat-section {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.chat-section .content {
  background-color: #fcf2f8;
  padding: 12px;
  border-radius: 10px;
  font-weight: 500;
}

.content {
  border: 1px solid #8080801f;
}

.chat-section.chat-user {
  justify-content: flex-end;
}

.chat-section.chat-user .content {
  background-color: #f2f4f5;
}

.chat-options p {
  margin: 8px 0;
  color: #d0006f;
  cursor: pointer;
  text-decoration: underline;
}

.chat-group-wrapper {
  margin-top: auto;
}

/* Chatbot Input (optional) */
.chatbot-input {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 10px 16px;
  border-top: 1px solid #ccccccaf;
  background: #fff;
}

.button-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
  /* Remove position, right, bottom */
}

.attach-file {
  font-size: 20px !important;
  color: #cb40b6 !important;
}

.chatbot-input .send-btn {
  background: linear-gradient(to right, #9433e988, #ea4788);
  border: none;
  border-radius: 5px;
  /* font-size: 18px; */
  cursor: pointer;
  color: #fff;
  padding: 6px 10px;
}

.chatbot-input textarea {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px;
  font-size: 14px;
  color: #cc007a;
  border-radius: 5px;
  border: 1px solid #ccccccaf;
  font-weight: 600;
}

.chatbot-input textarea:focus {
  border: 1px solid #ff8ad0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.chatbot-input textarea::placeholder {
  color: #cc007a;
  font-weight: 600;
}

.processing-dots span {
  animation: blink 1.4s infinite both;
  font-weight: bold;
  font-size: 18px;
  color: #ea479a;
  opacity: 0.7;
}
.processing-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.processing-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes blink {
  0%,
  80%,
  100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ea479a;
  border-top: 2px solid #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

<style>
@import url("../../style/style.css");
</style>
